import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import { useTranslation } from "react-i18next";
import Events from "./Events";

/**
 * @namespace EventsLog
 */

const EventsLogPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.journals") }, { label: t("title.eventsLog") }];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <Events />
    </>
  );
};

export default EventsLogPage;
